var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_20761",
    "data-name": "Raggruppa 20761",
    transform: "translate(-763.028 -431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32894",
    "data-name": "Tracciato 32894",
    d: "M36.028,30.647a7.5,7.5,0,1,1-7.5-7.5,7.5,7.5,0,0,1,7.5,7.5",
    transform: "translate(742 407.853)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32877",
    "data-name": "Tracciato 32877",
    d: "M29.361,29.814H27.695v5h1.667Zm0-2.5a.833.833,0,1,1-.833-.834.833.833,0,0,1,.833.834m6.667,3.333a7.5,7.5,0,1,1-7.5-7.5,7.5,7.5,0,0,1,7.5,7.5",
    transform: "translate(742 407.853)",
    fill: "#3260ce",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9dbeda00ea972ffa67ffa505ff9abf65.svg";
export { ForwardRef as ReactComponent };